export class LinkedConnectionModel {
    currentID: number;
    linkedConnections: Array<number>;

    constructor() {
        this.currentID = 0;
        this.linkedConnections = [];
    }
}

export class LinkedAppliesAcrossModel{
    currentID:number;
    linkedAppliesAcrossIds:Array<number>;

    constructor() {
        this.currentID = 0;
        this.linkedAppliesAcrossIds = [];
    }
}

export class OwnerCommentModel{
    id:number;
    fullName: string;
    ownerComment:string;
    constructor(){
        this.id = 0;
        this.fullName = "";
        this.ownerComment = "";
    }
}